import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { projectContextGuard } from './shared/guards/project-context.guard';
import { ProjectDashboardLayoutComponent } from './shared/components/project-dashboard-layout/project-dashboard-layout.component';
// The design system's Showcase, at /showcase. Development documentation, not shipped: this
// import is swapped for one that registers nothing in the production and staging builds, so
// the Showcase is absent from a deployed bundle rather than merely unreachable in it.
import { showcaseRoute } from './features/showcase/showcase-route';
import { onboardingStatusGuard } from './shared/guards/onboarding-status.guard';

/* App Routes */
export const routes: Routes = [
  ...showcaseRoute,
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    // Public: org invite-link landing. Redirects to login (preserving ?code=) when
    // unauthenticated, then completes the join and lands in the dashboard.
    path: 'join',
    loadComponent: () =>
      import('./features/join/pages/join-organization/join-organization.page').then((m) => m.JoinOrganizationPage),
  },
  {
    // Public: project invite-link landing. Same shape as /join, project-scoped.
    path: 'projects/join',
    loadComponent: () => import('./features/join/pages/join-project/join-project.page').then((m) => m.JoinProjectPage),
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    loadChildren: () => import('./features/onboarding/onboarding.routes').then((m) => m.onboardingRoutes),
  },
  {
    path: '',
    component: ProjectDashboardLayoutComponent,
    loadChildren: () => import('./features/dashboard/project-dashboard.routes').then((m) => m.projectDashboardRoutes),
    canActivate: [
      authGuard,
      // The only placement decision on this tree. `emailVerifiedGuard` and `hasOrganizationGuard`
      // used to sit here re-deriving "is the email verified" from a token claim and "is there an
      // organization" from `/dashboard/`; `onboarding_status` already answers both, and a second
      // opinion on either is a redirect loop waiting for the two to disagree.
      onboardingStatusGuard(['complete', 'legacy']),
      projectContextGuard,
    ],
    runGuardsAndResolvers: 'always',
  },
  {
    path: '**',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
];
